/*
  JILZARAH — Outlet jewelry browser (custom, not part of Flex)

  Presentation for sections/jilzarah-outlet-jewelry.liquid. It never touches quantities or
  the cart — that is the shared engine (assets/jilzarah-outlet.js). It only decides which
  of the once-rendered product cards are shown, and keeps the colour tiles, tab counts and
  design filters true to what is available right now.

  Two routes, one grid:
    Shop by Color   colour tiles (first available product's photo; a colour with nothing
                    left disappears; optionally one row with an arrow that opens the rest) → the
                    colour's pieces, with All / Necklaces / Earrings / Bracelets sub-tabs
    Shop by Style   Earrings / Necklaces / Bracelets tabs with live counts → design filters
                    + a colour select → the whole filtered assortment

  Availability is whatever the engine decided: a card the engine hid (data-jzo-item[hidden])
  is sold out. The engine fires "jzo:render" after every render, and this re-derives.

  Filtering uses a class (jzo-filtered), never the hidden attribute, so the engine's sold-out
  handling and this script's filtering cannot overwrite each other. Quantities live on the
  engine's pending map, keyed by variant, so they survive every switch here.
*/
(function () {
  'use strict';

  var TYPE_ORDER = ['Earring', 'Necklace', 'Bracelet'];

  function init(root) {
    if (root.dataset.jzoJewelryReady) return;
    root.dataset.jzoJewelryReady = '1';

    var cfgEl = root.querySelector('[data-jzo-jewelry-config]');
    var C; try { C = JSON.parse(cfgEl.textContent); } catch (e) { C = {}; }
    var COLORS = (C.colors || []).filter(function (c) { return c.name; });
    var STYLES = (C.styles || []);
    var byType = {}; STYLES.forEach(function (s) { byType[s.type] = s; });

    var grid = root.querySelector('[data-jzo-jgrid]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-jzo-item]'));
    var views = { color: root.querySelector('[data-jzo-view="color"]'), style: root.querySelector('[data-jzo-view="style"]') };
    var routes = Array.prototype.slice.call(root.querySelectorAll('[data-jzo-route]'));
    var tiles = Array.prototype.slice.call(root.querySelectorAll('[data-jzo-color]'));
    var colorName = root.querySelector('[data-jzo-color-name]'), colorBlurb = root.querySelector('[data-jzo-color-blurb]'), colorCount = root.querySelector('[data-jzo-color-count]');
    var subtabs = root.querySelector('[data-jzo-subtabs]'), styletabs = root.querySelector('[data-jzo-styletabs]'), designs = root.querySelector('[data-jzo-designs]');
    var colorSel = root.querySelector('[data-jzo-colorsel]'), showing = root.querySelector('[data-jzo-showing]'), empty = root.querySelector('[data-jzo-jempty]');

    var tileBox = root.querySelector('.jzo-colors'), moreBtn = root.querySelector('[data-jzo-color-more]');
    var stripBtns = Array.prototype.slice.call(root.querySelectorAll('[data-jzo-color-scroll]'));
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var state = { route: C.defaultRoute === 'style' ? 'style' : 'color', color: null, sub: '', type: null, design: '', colorFilter: '', allColors: false };

    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    /* the engine's writer: skips a row that came out the same, and hands focus back to the tab
       or filter that was pressed when its row is rewritten (see put() in jilzarah-outlet.js) */
    function put(el, html) { var E = window.JZOutlet; if (E && E.put) E.put(el, html); else el.innerHTML = html; }
    function avail(card) { return !card.hidden; }
    function live() { return cards.filter(avail); }
    function label(type) { var s = byType[type]; return s ? s.label : type + 's'; }
    function typesPresent() {
      var seen = {}; live().forEach(function (c) { seen[c.dataset.jzoPtype] = 1; });
      var t = TYPE_ORDER.filter(function (x) { return seen[x]; });
      Object.keys(seen).forEach(function (x) { if (t.indexOf(x) < 0) t.push(x); });
      return t;
    }
    function thumbOf(card) { var im = card.querySelector('img'); return im ? (im.currentSrc || im.src) : ''; }

    /* ---------- colour tiles: first available product's photo; empty colours vanish ---------- */
    function renderTiles() {
      var shown = 0;
      tiles.forEach(function (tile) {
        var name = tile.dataset.jzoColor;
        var first = live().filter(function (c) { return c.dataset.jzoPcolor === name; })[0];
        tile.hidden = !first;
        if (!first) return;
        shown++;
        var im = tile.querySelector('img'); var src = thumbOf(first);
        if (im && src && im.getAttribute('src') !== src) { im.src = src; im.alt = ''; }
        tile.setAttribute('aria-pressed', String(name === state.color));
      });
      if (colorCount) colorCount.textContent = (C.colorCount || '{n} colors').replace('{n}', shown);
      /* the chosen colour sold out → move to the first colour that still has pieces */
      var visibleTiles = tiles.filter(function (t) { return !t.hidden; });
      if ((!state.color || !visibleTiles.some(function (t) { return t.dataset.jzoColor === state.color; })) && visibleTiles.length) { state.color = visibleTiles[0].dataset.jzoColor; renderTiles(); return; }
      var meta = COLORS.filter(function (c) { return c.name === state.color; })[0] || {};
      if (colorName) colorName.textContent = state.color || '';
      if (colorBlurb) { colorBlurb.textContent = meta.blurb || ''; colorBlurb.hidden = !meta.blurb; }
      foldTiles(); stripArrows();
    }
    /* ---------- the swipeable colour row (phones): an arrow at each edge, shown only while the row has more that way ----------
       On wider screens the tiles are a grid that never overflows, so both arrows stay hidden. Nothing can be measured
       while the section is not displayed; the resize observer below re-measures when it is. */
    function stripArrows() {
      if (!tileBox || !stripBtns.length) return;
      var max = tileBox.scrollWidth - tileBox.clientWidth, x = tileBox.scrollLeft;
      stripBtns.forEach(function (b) { var dir = +b.dataset.jzoColorScroll; b.hidden = max <= 2 || (dir < 0 ? x <= 2 : x >= max - 2); });
    }
    /* ---------- one row of colours, the rest behind the arrow on the container's bottom edge (only when the section renders it) ----------
       The row is as many tiles as the grid has columns at this width; the chosen colour always stays in it (it takes
       the last place when it would have been folded away). A swipeable row (phones) is never folded. Nothing can be
       measured while the section is not displayed (another tab, the other route), so the fold waits until it is. */
    function tileColumns() {
      if (!tileBox || tileBox.offsetParent === null) return -1;
      var cs = getComputedStyle(tileBox);
      return cs.display === 'grid' ? cs.gridTemplateColumns.split(' ').filter(Boolean).length : 0;
    }
    function foldTiles() {
      if (!moreBtn) return;
      var cols = tileColumns(); if (cols < 0) return;
      var vis = tiles.filter(function (t) { return !t.hidden; });
      var over = cols > 0 && vis.length > cols;
      tiles.forEach(function (t) { t.classList.remove('jzo-ctile--more'); });
      if (over && !state.allColors) {
        var keep = vis.slice(0, cols);
        var chosen = vis.filter(function (t) { return t.dataset.jzoColor === state.color; })[0];
        if (chosen && keep.indexOf(chosen) < 0) keep[cols - 1] = chosen;
        vis.forEach(function (t) { if (keep.indexOf(t) < 0) t.classList.add('jzo-ctile--more'); });
      }
      moreBtn.hidden = !over;
      moreBtn.setAttribute('aria-expanded', String(!!state.allColors));
      /* the control is an arrow: its words are the label a screen reader and a hovering pointer get */
      var words = state.allColors ? (C.viewFewer || 'Show fewer colors') : (C.viewAll || 'View all {n} colors').replace('{n}', vis.length);
      moreBtn.setAttribute('aria-label', words); moreBtn.title = words;
    }
    function renderSubtabs() {
      if (!subtabs) return;
      var mine = live().filter(function (c) { return c.dataset.jzoPcolor === state.color; });
      var types = typesPresent().filter(function (t) { return mine.some(function (c) { return c.dataset.jzoPtype === t; }); });
      if (state.sub && types.indexOf(state.sub) < 0) state.sub = '';
      var html = '<button type="button" role="tab" data-jzo-sub="" aria-selected="' + (state.sub === '') + '">' + esc(C.allLabel || 'All pieces') + '</button>';
      types.forEach(function (t) { html += '<button type="button" role="tab" data-jzo-sub="' + esc(t) + '" aria-selected="' + (state.sub === t) + '">' + esc(label(t)) + '</button>'; });
      put(subtabs, html);
    }

    /* ---------- style tabs, design filters, colour select ---------- */
    function renderStyleTabs() {
      if (!styletabs) return;
      var types = typesPresent();
      if (!state.type || types.indexOf(state.type) < 0) state.type = types[0] || null;
      put(styletabs, types.map(function (t) {
        var n = live().filter(function (c) { return c.dataset.jzoPtype === t; }).length;
        return '<button type="button" role="tab" data-jzo-type="' + esc(t) + '" aria-selected="' + (t === state.type) + '">' + esc(label(t)) + ' <span class="jzo-styletabs__n">(' + n + ')</span></button>';
      }).join(''));
    }
    function renderDesigns() {
      if (!designs) return;
      var mine = live().filter(function (c) { return c.dataset.jzoPtype === state.type; });
      var seen = {}; var list = [];
      mine.forEach(function (c) { var d = c.dataset.jzoPdesign; if (!seen[d]) { seen[d] = 0; list.push(d); } seen[d]++; });
      list.sort(function (a, b) { return seen[b] - seen[a] || a.localeCompare(b); });
      if (state.design && !seen[state.design]) state.design = '';
      var html = '<button type="button" data-jzo-design="" aria-pressed="' + (state.design === '') + '">' + esc((C.allDesigns || 'All') + ' ' + label(state.type).toLowerCase()) + '</button>';
      list.forEach(function (d) { html += '<button type="button" data-jzo-design="' + esc(d) + '" aria-pressed="' + (state.design === d) + '">' + esc(d) + '</button>'; });
      put(designs, html);
      if (colorSel) {
        var cs = {}; mine.forEach(function (c) { var k = c.dataset.jzoPcolor; if (k) cs[k] = (cs[k] || 0) + 1; });
        var names = COLORS.map(function (c) { return c.name; }).filter(function (n) { return cs[n]; });
        if (state.colorFilter && !cs[state.colorFilter]) state.colorFilter = '';
        put(colorSel, '<option value="">All colors</option>' + names.map(function (n) { return '<option value="' + esc(n) + '"' + (n === state.colorFilter ? ' selected' : '') + '>' + esc(n) + ' (' + cs[n] + ')</option>'; }).join(''));
      }
    }

    /* ---------- the filter itself ---------- */
    function matches(card) {
      if (!avail(card)) return false;
      if (state.route === 'color') return card.dataset.jzoPcolor === state.color && (!state.sub || card.dataset.jzoPtype === state.sub);
      return card.dataset.jzoPtype === state.type && (!state.design || card.dataset.jzoPdesign === state.design) && (!state.colorFilter || card.dataset.jzoPcolor === state.colorFilter);
    }
    function applyFilter() {
      var n = 0;
      cards.forEach(function (c) { var on = matches(c); c.classList.toggle('jzo-filtered', !on); if (on) n++; });
      if (grid) grid.classList.toggle('jzo-jgrid--wide', state.route === 'color');
      if (empty) empty.hidden = n > 0;
      if (showing) {
        if (state.route === 'style' && state.type) {
          var t = live().filter(function (c) { return c.dataset.jzoPtype === state.type; }).length;
          showing.textContent = (C.showing || 'Showing {n} of {t} {style}').replace('{n}', n).replace('{t}', t).replace('{style}', label(state.type).toLowerCase());
          showing.hidden = false;
        } else showing.hidden = true;
      }
    }

    function render() {
      routes.forEach(function (b) { b.setAttribute('aria-selected', String(b.dataset.jzoRoute === state.route)); });
      Object.keys(views).forEach(function (k) { if (views[k]) views[k].hidden = k !== state.route; });
      renderTiles(); renderSubtabs(); renderStyleTabs(); renderDesigns(); applyFilter();
    }

    /* ---------- events ---------- */
    root.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b || !root.contains(b)) return;
      var d = b.dataset;
      if (d.jzoRoute !== undefined) { state.route = d.jzoRoute; render(); return; }
      if (d.jzoColorMore !== undefined) { state.allColors = !state.allColors; foldTiles(); return; }
      if (d.jzoColorScroll !== undefined) { tileBox.scrollBy({ left: +d.jzoColorScroll * Math.max(120, tileBox.clientWidth * 0.7), behavior: reduced ? 'auto' : 'smooth' }); return; }
      if (d.jzoColor !== undefined) {
        state.color = d.jzoColor; state.sub = ''; render();
        /* on a phone the colour strip fills the screen, so bring the chosen colour's heading (and its pieces) into view under the pinned bar */
        if (window.innerWidth < 700) {
          var head = root.querySelector('[data-jzo-color-name]'); var nav = document.querySelector('[data-jzo-nav]');
          if (head) { var y = head.getBoundingClientRect().top + window.scrollY - ((nav ? nav.getBoundingClientRect().height : 0) + 14); window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' }); }
        }
        return;
      }
      if (d.jzoSub !== undefined) { state.sub = d.jzoSub; render(); return; }
      if (d.jzoType !== undefined) { state.type = d.jzoType; state.design = ''; render(); return; }
      if (d.jzoDesign !== undefined) { state.design = d.jzoDesign; render(); return; }
    });
    if (colorSel) colorSel.addEventListener('change', function () { state.colorFilter = colorSel.value; render(); });
    /* arrow keys move between tabs/tiles in a group, as a tablist should */
    root.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      var b = e.target.closest('[role="tab"], [data-jzo-color], [data-jzo-design]'); if (!b) return;
      var group = b.parentElement; var all = Array.prototype.filter.call(group.children, function (x) { return x.tagName === 'BUTTON' && !x.hidden && !x.classList.contains('jzo-ctile--more'); });
      var i = all.indexOf(b); if (i < 0) return;
      var next = all[(i + (e.key === 'ArrowRight' ? 1 : all.length - 1)) % all.length]; if (next) { e.preventDefault(); next.focus(); next.click(); }
    });

    document.addEventListener('jzo:render', render);
    render();
    /* the fold depends on the grid's column count: redo it when the strip resizes or first becomes visible */
    if (tileBox && window.ResizeObserver) new ResizeObserver(function () { foldTiles(); stripArrows(); }).observe(tileBox);
    if (tileBox) tileBox.addEventListener('scroll', stripArrows, { passive: true });
  }

  function boot() { document.querySelectorAll('[data-jzo-jewelry]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target && e.target.querySelector && e.target.querySelector('[data-jzo-jewelry]'); if (r) init(r); });
})();
